// src/index.tsx

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Bootstrap JS (dropdowns, etc.)
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
